import * as turf from '@turf/turf';
import { Point } from 'geojson';
import { Position } from '@turf/helpers/dist/js/lib/geojson';

export const getCenter = (points: Position[]) => {
  const geoJsonPoint = turf.points(points) as GeoJSON.FeatureCollection<Point>;
  return turf.center(geoJsonPoint).geometry.coordinates;
};
